import React from "react";
import T from "prop-types";
import { Spinner } from "..";

export const ActionButton = ({ text, className, onClick, isLoading, marginTop, disabled, type, style }) => (
    <button className={className} onClick={onClick} disabled={disabled} type={type} style={style}>
        {isLoading ? (
            <Spinner size={20} color="white" loading={isLoading} style={{ marginTop: marginTop }} />
        ) : (
            <span>{text}</span>
        )}
    </button>
);

ActionButton.T = {
    onClick: T.func,
    className: T.string,
    text: T.string
};

ActionButton.defaultProps = {
    onClick: null,
    className: "primaryButtonCls",
    text: ""
};
